var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _radialGradient, _linearGradient17, _linearGradient18, _linearGradient19, _radialGradient2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSafety(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "0 -5 511.99982 511",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 240.9785255062,
    x2: 395.5108334754,
    y1: 79.4088340828,
    y2: 233.941142052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#c2e0ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#bfdcfd",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eb2e7"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 473.07314445,
    x2: 391.6928177172,
    xlinkHref: "#b",
    y1: 365.490061322,
    y2: 284.1097345892
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 487.433244738,
    x2: 254.076093487,
    xlinkHref: "#b",
    y1: 186.274423531,
    y2: 186.274423531
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 254.7490224036,
    x2: 451.0796228428,
    y1: 96.8223631338,
    y2: 293.152963573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8567,
    stopColor: "#0b9cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d94fe"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d94fe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5142,
    stopColor: "#0681cd",
    stopOpacity: 0.513725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070a2"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 400.3581704602,
    x2: 344.8777262288,
    xlinkHref: "#f",
    y1: 245.0602809474,
    y2: 189.579836716
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 313.567005324,
    x2: 364.8320814696,
    y1: 158.2691158112,
    y2: 209.5341919568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 405.9045383336,
    x2: 181.4632183646,
    xlinkHref: "#f",
    y1: 207.8802304618,
    y2: 134.1831195794
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45425a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3251"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 1573.002039 -8.311058)",
    gradientUnits: "userSpaceOnUse",
    x1: -753.7493,
    x2: -741.9286,
    xlinkHref: "#j",
    y1: 1443.3013,
    y2: 1443.3013
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 1573.002039 -8.311058)",
    gradientUnits: "userSpaceOnUse",
    x1: -734.4884,
    x2: -754.5899,
    y1: 1449.3564,
    y2: 1429.2549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3251",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 54.2149001582,
    x2: 99.2613822592,
    y1: 408.8028705212,
    y2: 453.8493526222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1596,
    stopColor: "#ff6440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    stopColor: "#ff4b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7662,
    stopColor: "#ff216e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0084"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 1573.002039 -8.311058)",
    gradientUnits: "userSpaceOnUse",
    x1: -729.3061,
    x2: -762.5703,
    y1: 1328.4481,
    y2: 1280.3999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0084",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737,
    stopColor: "#f4087e",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3347,
    stopColor: "#d2216b",
    stopOpacity: 0.333333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#ba335e",
    stopOpacity: 0.584314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#ab3d56",
    stopOpacity: 0.811765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 1573.002039 -8.311058)",
    gradientUnits: "userSpaceOnUse",
    x1: -756.643,
    x2: -737.4905,
    y1: 1289.3173,
    y2: 1289.3173
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2296,
    stopColor: "#ffd355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4362,
    stopColor: "#ffcf4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#ffc838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb400"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 1573.002039 -8.311058)",
    gradientUnits: "userSpaceOnUse",
    x1: -736.4652,
    x2: -765.3004,
    y1: 1294.9219,
    y2: 1253.271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0396,
    stopColor: "#e27f04",
    stopOpacity: 0.039216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#c15d2f",
    stopOpacity: 0.466667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    stopColor: "#ad4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 252.1319648272,
    cy: 282.1425455946,
    gradientUnits: "userSpaceOnUse",
    r: 150.3193492962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    stopColor: "#a0b4d6",
    stopOpacity: 0.482353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    stopColor: "#9cafcf",
    stopOpacity: 0.654902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    stopColor: "#94a6c4",
    stopOpacity: 0.776471
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8765,
    stopColor: "#8a9bb3",
    stopOpacity: 0.878431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#7c8b9d",
    stopOpacity: 0.960784
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 451.5095022432,
    x2: 315.6535568088,
    xlinkHref: "#f",
    y1: 307.4092583262,
    y2: 171.553413284
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 78.2546155858,
    x2: 400.4601689354,
    xlinkHref: "#j",
    y1: 261.921452114,
    y2: 261.921452114
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 612.050824 406.920741)",
    gradientUnits: "userSpaceOnUse",
    x1: 234.7998,
    x2: 507.6757,
    xlinkHref: "#j",
    y1: 144.4291,
    y2: 144.4291
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 250.861903105,
    cy: 280.1322921818,
    gradientUnits: "userSpaceOnUse",
    r: 135.3744644432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4554,
    stopColor: "#a3b6d9",
    stopOpacity: 0.454902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6194,
    stopColor: "#aabcdc",
    stopOpacity: 0.619608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    stopColor: "#b5c5e0",
    stopOpacity: 0.737255
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    stopColor: "#c6d2e8",
    stopOpacity: 0.831373
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    stopColor: "#dce4f1",
    stopOpacity: 0.913725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9822,
    stopColor: "#f7f9fc",
    stopOpacity: 0.980392
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m451.648438 29.296875-63.191407-19.03125c-43.234375-13.019531-89.351562-13.019531-132.585937 0l-63.1875 19.03125c-9.527344 2.871094-17.1875 9.988281-20.746094 19.277344l-30.222656 78.925781c-22.378906 58.449219-3.800782 124.65625 45.726562 162.921875l82.628906 63.84375c30.683594 23.710937 73.503907 23.710937 104.1875 0l82.628907-63.84375c49.527343-38.265625 68.105469-104.472656 45.726562-162.921875l-30.222656-78.925781c-3.558594-9.289063-11.21875-16.40625-20.742187-19.277344zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m476.863281 271.636719c-5.953125 6.796875-12.621093 13.101562-19.980469 18.785156l-82.621093 63.847656c-1.917969 1.488281-3.886719 2.871094-5.894531 4.167969 20.160156-26.894531 32.097656-60.316406 32.097656-96.515625 0-43.441406-17.199219-82.875-45.15625-111.847656zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m374.257812 354.265625 82.628907-63.84375c49.527343-38.265625 68.109375-104.472656 45.726562-162.921875l-30.222656-78.925781c-3.558594-9.289063-11.21875-16.40625-20.746094-19.277344l-63.1875-19.03125c-21.617187-6.511719-43.957031-9.765625-66.292969-9.765625v371.546875c18.378907 0 36.753907-5.925781 52.09375-17.78125zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m433.277344 51.566406-54.222656-16.332031c-37.101563-11.171875-76.675782-11.171875-113.777344 0l-54.226563 16.332031c-8.171875 2.460938-14.746093 8.570313-17.796875 16.542969l-25.9375 67.726563c-19.207031 50.15625-3.257812 106.972656 39.238282 139.8125l70.90625 54.785156c26.332031 20.34375 63.078124 20.34375 89.410156 0l70.90625-54.785156c42.5-32.839844 58.445312-89.65625 39.238281-139.8125l-25.9375-67.726563c-3.054687-7.972656-9.625-14.082031-17.800781-16.542969zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m459.589844 184.300781c0-3.832031-.164063-7.625-.46875-11.378906l-52.929688-52.925781c-5.605468-5.609375-14.695312-5.609375-20.304687 0l-76.820313 76.820312c-5.605468 5.605469-14.695312 5.605469-20.300781 0l-30.324219-30.324218c-5.605468-5.605469-14.695312-5.605469-20.304687 0l-13.46875 13.472656c-5.609375 5.605468-5.609375 14.695312 0 20.300781l119.667969 119.671875c65.355468-10.601562 115.253906-67.289062 115.253906-135.636719zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m286.394531 261.992188c6.914063 6.917968 18.128907 6.917968 25.042969 0l108.226562-108.222657c5.605469-5.605469 5.605469-14.695312 0-20.304687l-13.472656-13.46875c-5.605468-5.605469-14.695312-5.605469-20.304687 0l-76.820313 76.820312c-5.605468 5.609375-14.695312 5.609375-20.300781 0l-30.324219-30.320312c-5.609375-5.609375-14.699218-5.609375-20.304687 0l-13.46875 13.46875c-5.609375 5.605468-5.609375 14.695312 0 20.300781zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m366.867188 330.433594 70.90625-54.785156c42.5-32.835938 58.445312-89.65625 39.238281-139.808594l-25.933594-67.730469c-3.054687-7.96875-9.625-14.078125-17.800781-16.539063l-54.222656-16.332031c-18.550782-5.589843-37.722657-8.382812-56.890626-8.382812v318.839843c15.769532 0 31.539063-5.089843 44.703126-15.261718zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m8.257812 495.84375-2.917968-2.917969c-7.121094-7.117187-7.121094-18.660156 0-25.78125l6.886718-6.886719 28.699219 28.699219-6.886719 6.886719c-7.121093 7.117188-18.664062 7.117188-25.78125 0zm0 0",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m34.039062 495.84375 6.886719-6.886719-28.699219-28.699219-6.886718 6.886719c-.265625.265625-.519532.539063-.765625.820313v24.144531c.246093.277344.5.550781.765625.816406l2.917968 2.917969c7.117188 7.117188 18.660157 7.117188 25.78125 0zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m20.578125 490.503906-9.902344-9.902344c-8.117187-8.117187-8.117187-21.277343 0-29.394531l85.945313-85.941406c8.117187-8.121094 21.277344-8.121094 29.394531 0l9.902344 9.902344c8.117187 8.117187 8.117187 21.277343 0 29.394531l-85.945313 85.941406c-8.117187 8.117188-21.277344 8.117188-29.394531 0zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m94.988281 375.5625v61.261719l47.015625-47.015625-30.628906-30.632813zm0 0",
    fill: "url(#n)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m122.511719 403.746094-25.074219-25.074219c-5.917969-5.917969-5.917969-15.507813 0-21.425781l21.332031-21.332032 46.496094 46.496094-21.332031 21.335938c-5.914063 5.914062-15.507813 5.914062-21.421875 0zm0 0",
    fill: "url(#o)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m104.644531 350.050781v35.828125l17.867188 17.867188c5.914062 5.917968 15.507812 5.917968 21.421875 0l21.335937-21.335938-46.5-46.496094-14.125 14.125zm0 0",
    fill: "url(#p)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m363.46875 261.921875c0 68.546875-55.566406 124.113281-124.113281 124.113281-68.542969 0-124.109375-55.566406-124.109375-124.113281 0-68.542969 55.566406-124.109375 124.109375-124.109375 68.546875 0 124.113281 55.566406 124.113281 124.109375zm0 0",
    fill: "url(#q)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m355.308594 150.074219c27.957031 28.972656 45.15625 68.40625 45.15625 111.847656 0 16.800781-2.574219 33-7.347656 48.230469l44.660156-34.503906c8.210937-6.347657 15.421875-13.59375 21.585937-21.511719zm0 0",
    fill: "url(#r)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m239.355469 100.820312c-88.972657 0-161.101563 72.128907-161.101563 161.101563 0 88.980469 72.128906 161.101563 161.101563 161.101563 88.972656 0 161.105469-72.121094 161.105469-161.101563 0-88.972656-72.128907-161.101563-161.105469-161.101563zm0 285.210938c-68.539063 0-124.109375-55.5625-124.109375-124.109375 0-68.542969 55.570312-124.113281 124.109375-124.113281 68.542969 0 124.113281 55.570312 124.113281 124.113281 0 68.550781-55.570312 124.109375-124.113281 124.109375zm0 0",
    fill: "url(#s)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m239.355469 398.902344c75.648437 0 136.972656-61.324219 136.972656-136.972656 0-75.648438-61.324219-136.980469-136.972656-136.980469-75.644531 0-136.972657 61.332031-136.972657 136.980469 0 75.648437 61.328126 136.972656 136.972657 136.972656zm0-261.085938c68.542969 0 124.113281 55.5625 124.113281 124.113282 0 68.539062-55.570312 124.109374-124.113281 124.109374-68.539063 0-124.109375-55.570312-124.109375-124.109374 0-68.550782 55.570312-124.113282 124.109375-124.113282zm0 0",
    fill: "url(#t)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m351.128906 261.921875c0 61.730469-50.042968 111.773437-111.773437 111.773437-61.726563 0-111.769531-50.042968-111.769531-111.773437 0-61.726563 50.042968-111.769531 111.769531-111.769531 61.730469 0 111.773437 50.042968 111.773437 111.769531zm0 0",
    fill: "url(#u)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSafety);
export default __webpack_public_path__ + "static/media/icon-safety.968aa689e425c8329239fcf3abeac89b.svg";
export { ForwardRef as ReactComponent };